import {NumberValue} from "@app/common/components/viewers/configurator/extensions/bd-cloud/types"
import {ExtensionContext} from "@app/common/components/viewers/configurator/extensions/configurator-api-extension"
import {NumberInfo} from "@cm/template-nodes"
import {dimensionPathName, mattressNumberInputMetaDataSchema} from "@cm/mattress-nodes"

export function getDimensions(context: ExtensionContext): NumberValue[] {
    const {sceneManagerService} = context
    const descriptors = sceneManagerService.$descriptorList()

    return descriptors
        .flatMap((d) => {
            if (!(d instanceof NumberInfo)) return []
            const parsed = mattressNumberInputMetaDataSchema.safeParse(d.props.metaData)
            if (!parsed.success) return []
            const metaData = parsed.data
            const hasDimensionPath = metaData.uiPaths.some((t) => t.name === dimensionPathName)
            return hasDimensionPath ? [{descriptor: d, metaData}] : []
        })
        .sort((a, b) => a.metaData.rank - b.metaData.rank)
        .map(({descriptor: d, metaData}) => ({
            inputId: d.props.id,
            name: d.props.name,
            value: d.props.value ?? 0,
            min: metaData.min,
            max: metaData.max,
        }))
}
